import React, {Fragment} from 'react'

import {useState, useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useFirebase, useFirestore, useFirestoreConnect } from 'react-redux-firebase'
import {Label, Image, Button, Input, Menu, Icon} from 'semantic-ui-react'
import {env} from '../../constants/Environment';
const moment = require('moment')

function FirebaseImage(props){
    const [url, setUrl] = useState(null);

    useEffect(() => {
        props.storage.ref(props.image.path).getDownloadURL()
        .then((downloadUrl) => {
            setUrl(downloadUrl);
        });
    }, [props.image]);

    if(url === null)
        return null;
    else
        return (
            <Image size="small" src={url} onClick={(e) => {
                if(typeof props.onClick === 'function')
                    props.onClick(url);
            }} />
        )
}

function Imagelist(props){
    const [activeItem, setActiveItem] = useState(null);

    useFirestoreConnect([
        { 
            collection: 'environments/' + env + '/images/imagetool/publications/channels/' + props.channel,
            orderBy: ['timestamp', 'desc'],
            limit: 50
        }
    ])

    const images = useSelector(({ firestore: { data } }) => data['environments/' + env + '/images/imagetool/publications/channels/' + props.channel])

    return (
        <Menu fluid vertical>
            {
                (typeof images !== 'undefined' && images !== null)?
                    Object.values(images).map((image, idx) => {
                        
                        return (
                            <Menu.Item key={idx}>
                                <FirebaseImage storage={props.storage} image={image} onClick={(imageUrl) => {
                                    props.chooseImage({...image, url: imageUrl});
                                }} />
                            </Menu.Item>
                        )
                    })
                :null
            }
        </Menu>
    )
}

export default function ImagePicker(props){
    const [storage, setStorage] = useState(null);

    const firebase = useFirebase();

    useEffect(() => {
        if(storage === null)
            setStorage(firebase.app().storage("gs://imagetool"));
    }, [false])

    if(storage === null)
        return null;

    return (
        <Imagelist storage={storage} channel={props.channel} chooseImage={(image) => props.chooseImage(image)} />
    )
}